import React, { useState, useEffect, useImperativeHandle, forwardRef, } from "react";
import { Box, Typography } from "@mui/material";
import './ChannelDetail.css';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import {
  useDispatch, useSelector
} from "react-redux";
import { getUsers } from "../../../../Store/Features/Users/UserSlice";
import { del_apiKey, genApikey } from "../../../../Store/Features/Users/UserSlice";
import CircularProgress from '@mui/material/CircularProgress';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { current } from "@reduxjs/toolkit";
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';


export const GenerateApi_KeyForm = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [api_key, setApi_Key] = useState("");
  const [count, setCount] = useState([{
    id: '',
    name: '',
    email: '',
    api_key: ''
  }]);
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(0);
  const [genApikey_loader, setApikey_loader] = useState(false);

  const userdata = useSelector(state => state.usersSlice.value);
  const Loading = useSelector(state => state.usersSlice.loading);
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    dispatch(getUsers())
  }, [])

  useEffect(() => {
    console.log("userData", userdata)
    let filteredData = userdata.filter(row => row.api_key != null);
    let users = userdata.filter(row => row.api_key == null);
    console.log('filteredData', filteredData)
    setCount(filteredData);
    setUsers(users);
    console.log("count state is ", count)

  }, [userdata])


  const removeWebhook = (index, id) => {
    const options = {

      title: 'Confirmation',
      message: 'Are you sure to delete Api_Key?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const temp = [...count];
            const index1 = temp.findIndex(item => item.id == index)
            console.log("index", index1)
            temp.splice(index, 1);
            setCount(temp);
            const Id = id;
            if (Id) {
              dispatch(del_apiKey(Id)).then(() => {
                dispatch(getUsers(slug))
              });
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            console.log('here is iside no');
          }
        }
      ],
    }
    console.log('here is options object', options)
    confirmAlert(options);
  };

  const handleUserChange = (e) => {
    setApi_Key(e.target.value);
    setUserId(e.target.value);
    console.log('api key id-------------------------', e.target.value)
  };

  const toasterMessage = (msg) => {
    toast.error(msg);
  }

  const generateKey = (index) => {
    setApikey_loader(true)
    if (userId == 0) {
      toasterMessage('Please Select User First');
      setApikey_loader(false)
      return;
    }
    dispatch(genApikey(userId)).then((res) => {
      setApikey_loader(false)
      dispatch(getUsers())
    })
  }

  const columns = [
    { field: 'name', headerName: 'User', flex: 1 },
    { field: 'api_key', headerName: 'Api_Key', flex: 1 },
    {
      field: ' ',
      headerName: '',
      flex: 1,
      renderCell: (params) => (
        <Button className="hover" sx={{ backgroundColor: "#ec492f", height: 28 }} onClick={() => removeWebhook(params.row.id, params.row.id)}  >
          <Typography className="button">Remove</Typography>
        </Button >
      )
    },
  ];

  return (<>
    {Loading ? (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "40vh", m: 4 }} > <CircularProgress />
    </Box >
    ) : (
      <>
    {genApikey_loader?(
      <Box sx={{height:"20px"}} > 
      <CircularProgress />
      </Box >
    ):(null)
    }
    

        <Box className="Box3">
          <Select1 value={userId} eventHandler={handleUserChange} users={users} />
          <Box className="Title12">
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Button className="hover" sx={{ background: "#EC492F", height: "56px" }} onClick={() => generateKey()}  >
                <Typography className="button1">
                  Generate-Api-key
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>

        <Box className="Table" sx={{ m: 4 }}>
          <DataGrid

            rows={count}
            columns={columns}

            autoHeight
            slots={{
              pagination: CustomPagination,
            }}
          />
        </Box>


      </>
    )
    };
  </>

  );



});

function Select1({ value, eventHandler, users }) {
  console.log('users', users)
  return (
    <FormControl sx={{ width: "30%" }}>
      <InputLabel sx={{
        "font-family": "Circe",
        "font-size": "14px",
        "font-weight": 400,
        top: "3px"
      }}>Users</InputLabel>

      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="Add User"
        key="Add User"
        onChange={e => eventHandler(e)}
        className=''
      >
        <MenuItem value={0} selected>Select user to gen key</MenuItem>
        {users?.map((item, index) => {
          if (item.api_key == null) {
            return (
              <MenuItem value={item.id} >{item.name}</MenuItem>
            )
          }
        }
        )}

      </Select>
    </FormControl>

  );
}

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination

      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      sx={{
        '& .Mui-selected': {
          backgroundColor: 'transparent !important',
          color: '#ec492f',
        },
      }}
      renderItem={(props2) => <PaginationItem className="paginationText"  {...props2} />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}